import { OverlayAnnotations } from '@readcloud/common';
import * as t from 'io-ts';
import React from 'react';
import { ScaleWithPageContainer } from '../ScaleWithPageContainer';
import { AnnotationRendererProps } from '../types';
const shapeAnnotation = t.union([
  OverlayAnnotations.circleAnnotation,
  OverlayAnnotations.rectangleAnnotation,
]);
type ShapeAnnotation = t.TypeOf<typeof shapeAnnotation>;
export const ShapeAnnotationViewer = React.memo(function ShapeAnnotationViewer(
  props: AnnotationRendererProps<
    ShapeAnnotation['data'],
    ShapeAnnotation['type']
  >
) {
  const render = React.useCallback(
    ({ height, width }: { height: number; width: number }) => {
      switch (props.type) {
        case 'Circle':
          return (
            <div
              style={{
                height,
                width,
                position: 'relative',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  margin: 'auto',
                  width, //Math.min(height, width), -- Uncomment this if you want it to be a circle
                  height, //Math.min(height, width), -- Uncomment this if you want it to be a circle
                  borderRadius: '50%',
                  borderColor: props.data.stroke,
                  borderWidth: props.data.strokeWidth,
                  borderStyle: 'solid',
                  backgroundColor: props.data.fill,
                }}
              />
            </div>
          );
        case 'Rectangle':
          return (
            <svg height={height} width={width}>
              <rect
                height={height}
                width={width}
                stroke={props.data.stroke}
                strokeWidth={props.data.strokeWidth}
                fill={props.data.fill}
              />
            </svg>
          );
      }
    },
    [props]
  );

  return (
    <ScaleWithPageContainer
      height={props.height}
      width={props.width}
      scale={props.scale}
      scaleWithPage={!!props.data.scaleWithPage}
    >
      {render}
    </ScaleWithPageContainer>
  );
});
